// i18n system — thin wrapper over dictionary lookup.
// The active language lives on settingsStore so it persists automatically.
import { useSettings } from "@/stores/settingsStore";
import en from "./en";
import it from "./it";
import ru from "./ru";
import uk from "./uk";

const DICT = { en, it, ru, uk };
export const LANGUAGES = [
    { code: "en", label: "English" },
    { code: "it", label: "Italiano" },
    { code: "ru", label: "Русский" },
    { code: "uk", label: "Українська" },
];

/**
 * Translate a key. Falls back to English, then to the raw key.
 * @param {string} key
 * @param {string} [lang]
 */
export function t(key, lang) {
    const language = lang || useSettings.getState().language || "en";
    return DICT[language]?.[key] || DICT.en[key] || key;
}

/**
 * React hook — re-renders when the language changes.
 */
export function useT() {
    const language = useSettings((s) => s.language);
    return (key) => DICT[language]?.[key] || DICT.en[key] || key;
}
